export enum ClientNotificationOTPType {
  PayBookingAndChangeStatus = 1,
  BillDiscount = 2,
  PackageItemsWorkDone = 3
}
